
// eslint-disable-next-line
export const SET_LANGUAGE = 'locale/set-language';
